import AccountBadges from './AccountBadges'

export default AccountBadges
